module.exports = __webpack_public_path__ + "img/logo_white.bac95b18.svg";